import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {ComponentController} from "../../../infrastructure/controllers/component-controller";
import {StandingsWidgetState} from "../models/standings-widget.state";
import {StandingsWidgetController} from "../standings-widget.controller";
import {WebsiteModuleState} from "../../../apps/website/models/website-module.state";
import {StandingsDomainModel} from "../../../domain/standings/models/standings.domain-model";
import {action, runInAction} from "mobx";
import {COMPONENT_STATES} from "../../../core/consts";

export class StandingsWidgetPopulateDataHandler extends PopulateDataHandler {
  controller: StandingsWidgetController;
  state: StandingsWidgetState;
  static injectables = [...PopulateDataHandler.injectables, WebsiteModuleState];

  constructor(websiteModuleState: WebsiteModuleState) {
    super();

    this.websiteModuleState = websiteModuleState;
  }

  @action onInitialized(controller: ComponentController) {
    super.onInitialized(controller);

    runInAction(() => {
      this.state.isPreviewStandings = controller.props.isPreviewStandings;
      this.state._isSmallView = controller.props.isSmallView;
      this.state.collapsedCompetitorIds = controller.props.collapsedCompetitorIds || [];
      this.state.lastSelectedStandingsCompetition = controller.props.competitionIds?.first();
    })
  }

  @action onLoaded() {
    super.onLoaded();


    runInAction(() => {
      this.state.collapsedCompetitorIds = this.controller.props.collapsedCompetitorIds || [];
      const competitorId: Number = this.controller.props.competitorId;
      const competitorsIds: Array<Number> = this.controller.props.location?.state?.highlightedCompetitors;

      competitorId && this.state.highlightedCompetitors.push(competitorId)
      competitorsIds?.forEach(id => this.state.highlightedCompetitors.push(id))
    })
  }

  async action(params) {
    const standings = params.dataSource?.standings?.first();
    const competitorId = Number(this.controller.props.competitorId)

    runInAction(() => {
      this.initialStandings(params.dataSource, standings);
      this.store.setComponentState(COMPONENT_STATES.loaded);
    })

    if (params?.initDataSource) {
      runInAction(() => {
        this.state.dataSource = params.dataSource;
        this.state.competitorId = competitorId;
      });
    }
  }

  @action initialStandings(dataSource, standings: StandingsDomainModel) {
    this.state.isPreviewStandings = this.controller.props.isPreviewStandings;
    this.state.collapsedCompetitorIds = this.controller.props.collapsedCompetitorIds || [];
    this.state.selectedCompetitionId = standings?.competition?.id;

    if(!this.state.selectedSeasonNum) {
      this.state.selectedSeasonNum = standings?.seasonNum;
    }

    if (standings) {
      this.state.currentStageNum = standings?.stageNum;
    }

    if (!this.state.selectedTabIndex > 0) {
      const isGroupCategory = standings?.currentGroupCategory > 0;
      const defaultGroupCategory = standings?.groupCategories?.findIndex(group => group.num === standings?.currentGroupCategory);

      this.state.selectedTabIndex = isGroupCategory ? defaultGroupCategory : 0;
    }
  }

  onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps);

    runInAction(() => {
      if (JSON.stringify(nextProps.collapsedCompetitorIds) !== JSON.stringify(prevProps.collapsedCompetitorIds)) {
        this.state.collapsedCompetitorIds = nextProps.collapsedCompetitorIds || [];
      }

      this.state._isSmallView = nextProps.isSmallView;
    })
  }
}
